/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

function setStyle(el, styles) {
  var keys = Object.keys(styles);
  keys.forEach(function (key) {
    el.style[key] = styles[key];
  });
}

export { setStyle as s };
//# sourceMappingURL=dep-b0b0fb5e.mjs.map
